<template>
  <div class="ltv">
    <ErrorPage v-if="!isActive" 
      code=503 
      :custom-message='inActiveMessage' 
    />
    <div class="container" v-if="isActive">
      <div class="row ltv-panel">
        <div class="col-lg-8 col-12 order-lg-2">
          <Flowplayer src='http://localhost/Maroon-5-Sugar.mp4' />
        </div>
        <div class="col-lg-4 col-12 order-lg-1">
          <div class="ltv-sidebar">
            <div class="ltv-sidebar-header">
              <div class="dropdown">
                <h4 id="dropdownMenuButton" data-toggle="dropdown" 
                  aria-haspopup="true" aria-expanded="false"
                  class='dropdown-toggle'
                >
                  All Channels</h4>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a class="dropdown-item" href="#">Sports</a>
                  <a class="dropdown-item" href="#">Entertainment</a>
                  <a class="dropdown-item" href="#">Cartoon</a>
                </div>
              </div>
              <span class="d-block">Watching - 1 / 76</span>
            </div>
            <div class="ltv-list">
              <div class="">
                <perfect-scrollbar style="height: 400px;">
                  <ul class="list-unstyled ltv-single">
                    <li class="media" v-for="(channel, index) in channels" v-bind:key="index">
                      <span class='play-icon fa fa-play' v-if='channel.isPlaying'></span>
                      <div style="background-image: url(https://image.tmdb.org/t/p/w500//uQM4WJP8hpz5ClErWEF9utZXVMs.jpg)" 
                        class="mr-3 ltv-single-thumb" alt="Image address"></div>
                      <div class="media-body">
                        <h5 class="mt-0 mb-1">{{ channel.title }}</h5>
                        <a href="#" class="catg-tag">
                          {{ channel.category }}
                        </a>
                      </div>
                    </li>
                  </ul>
                </perfect-scrollbar>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
import Flowplayer from '../components/Flowplayer'
import { getLocalStorage } from '../app/helpers';
import ErrorPage from '../components/ErrorPage'

export default {
  components: {
    PerfectScrollbar,
    Flowplayer,
    ErrorPage
  },
  data() {
    return {
      isActive: true,
      inActiveMessage: `Sorry for inconveniance! this feature from AxeTV is
        currently under maintenance and will be live soon. You will be informed once 
        it's back`,
      user: {},
      channels: [
        {
          title: 'ARY News',
          isPlaying: true,
          category: 'Social'
        },
        {title: 'Geo TV Channel',
          category: 'Sport'},
        {title: 'Facebook live TV',
          category: 'News Channel'},
        {title: 'ARY News',
          category: 'Sport'},
        {title: 'Geo TV Channel',
          category: 'Entertainment'},
        {title: 'Facebook live TV',
          category: 'Entertainment'}
      ]
    }
  },
  mounted() {
    this.$store.commit('bodyClass', 'live-tv bg-1')
    // this.$store.commit('hasHeader', this.isActive ? false : true);
    this.user = getLocalStorage('user').user || {};
  }
}
</script>

<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css"/>
<style lang="scss">
.ltv-logo {
  max-width: 106px;
  margin: 5px auto;
}
.ltv-header-text {
  background: green;
  padding: 0px 10px;
  color: white;
  margin: 17px 0px;
  display: inline-block;
  font-size: 13px;
  letter-spacing: 1px;
  font-weight: 500;
  border-radius: 2px;
  width: 56px;
  padding-left: 6px;
  margin-top: 22px;
  margin-left: 9px;
  position: absolute;

  i {
    display: inline-block;
    width: 7px;
    height: 7px;
    background: white;
    border-radius: 100px;
    margin-right: 4px;
    position: relative;
    top: -1px;
  }
}
.ltv-panel {
  margin-top: 50px;

  .ltv-sidebar {
    background: #212121;
  }

  .ltv-sidebar-header {
    padding: 10px 25px;

    h4 {
      font-size: 16px;
      color: white;
      font-weight: 500;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }

    .dropdown-menu {
      background: #010101;
      box-shadow: 0px 0px 13px -1px #0a0a0a;
      border: 1px solid #101010;
    }

    .dropdown-item:hover {
      color: red;
      background:transparent;
    }

    span {
      color: white;
      font-size: 12px;
    }
  }
  
}

.ltv-header-search {
  height: 100%;
  padding: 10px 0px;
  margin-top: 2px;
  width: calc(100% - 400px);
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  max-width: 580px;

  input {
    background: #151515;
    border-color: #252525;
  }

  button {
    margin-top: -5px;
    margin-left: 5px;
    background: #3a3a3a;
    color: #1d1c1c;
    padding: 5px 12px;
  }
}

.ltv-list {
    background: #080808;
}

.ltv-single .media {
  padding: 8px 25px;
  cursor: pointer;
  border-bottom: 1px solid #0c0c0c;
  position: relative;

  &:hover {
    background-color: #040404;
  }

  > img {
    max-width: 50px;
  }
  h5 {
    color: white;
    font-size: 15px;
  }

  .play-icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 12px;
  }

  .ltv-single-thumb {
    display: inline-block;
    width: 60px;
    height: 60px;
    background-size: cover;
  }

  .catg-tag {
    background: #444444;
    display: inline-block;
    color: white;
    padding: 1px 12px;
    font-size: 11px;
    border-radius: 10px;
  }
}
</style>